module.exports = __webpack_public_path__ + "static/img/h11.d40049f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h11.jpg
// module id = vDcH
// module chunks = 0